var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleTopOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-top-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7311 14.313L13.4051 8.597C12.6621 7.801 11.3391 7.801 10.5951 8.597L5.26909 14.312C4.89209 14.716 4.91409 15.351 5.31709 15.729C5.72109 16.108 6.35309 16.086 6.73109 15.681L12.0001 10.027L17.2691 15.682C17.4661 15.893 17.7331 16 18.0001 16C18.2451 16 18.4901 15.911 18.6831 15.73C19.0861 15.351 19.1081 14.717 18.7311 14.313Z",
    fill: "#123DA1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleTopOutline);
export default __webpack_public_path__ + "static/media/angle-top-outline.0f966906811d5255ac17652082ff7608.svg";
export { ForwardRef as ReactComponent };